import type { AgentPreset } from "@/types";

export const AGENT_PRESETS: Record<string, AgentPreset> = {
  copilot: {
    name: "GitHub Copilot",
    command: "copilot",
    args: ["--acp"],
    description:
      "Sign in with GitHub. Included with Copilot subscription.",
    installMethod: "npm",
    installPackage: "@github/copilot",
    installGlobal: true,
    authType: "oauth-device-code",
    authCommand: null,
    authPattern:
      /First copy your one-time code: (\S+).*open (https:\/\/\S+)/s,
    requiresAuth: "GitHub login",
    website: "https://github.com/features/copilot/cli",
    acpSupport: "native",
  },
  codex: {
    name: "OpenAI Codex",
    command: "codex-acp",
    args: [],
    description:
      "Sign in with your OpenAI account.",
    installMethod: "npm",
    installPackage: "@zed-industries/codex-acp",
    installGlobal: true,
    installDependencies: [{ package: "@openai/codex", global: true }],
    authType: "oauth-device-code",
    authCommand: ["codex", "login"],
    authPattern: /open (https:\/\/\S+).*code[:\s]+(\S+)/is,
    requiresAuth:
      "OpenAI login",
    website: "https://developers.openai.com/codex/cli/",
    acpSupport: "native",
  },
  claude: {
    name: "Claude",
    command: "claude-code-acp",
    args: [],
    description: "Sign in with your Anthropic account.",
    installMethod: "npm",
    installPackage: "@zed-industries/claude-code-acp",
    installGlobal: true,
    installDependencies: [{ package: "@anthropic-ai/claude-code", global: true }],
    authType: "oauth-device-code",
    authCommand: null,
    authPattern: /open (https:\/\/\S+)/i,
    requiresAuth: "Claude Pro or Max login",
    website: "https://docs.anthropic.com/en/docs/claude-code",
    acpSupport: "native",
  },
  gemini: {
    name: "Google Gemini",
    command: "gemini",
    args: ["--acp"],
    description:
      "Sign in with your Google account.",
    installMethod: "npm",
    installPackage: "@google/gemini-cli@0.31.0",
    installGlobal: true,
    authType: "oauth-browser",
    authCommand: null,
    authPattern: /open (https:\/\/accounts\.google\.com\S+)/i,
    requiresAuth: "Google login",
    website: "https://github.com/google-gemini/gemini-cli",
    acpSupport: "experimental",
  },
  opencode: {
    name: "OpenCode",
    command: "opencode",
    args: ["acp"],
    description: "Open-source agent. Bring your own API key.",
    installMethod: "npm",
    installPackage: "opencode-ai",
    installGlobal: true,
    authType: "api-key",
    authEnvVar: "ANTHROPIC_API_KEY",
    requiresAuth: "API key required",
    website: "https://opencode.ai",
    acpSupport: "native",
  },
  custom: {
    name: "Custom Agent",
    command: "",
    args: [],
    description:
      "Provide your own ACP-compatible agent binary and arguments.",
    installMethod: "manual",
    authType: "manual",
    requiresAuth: "Depends on agent",
    acpSupport: "native",
  },
};
